import React from 'react';
import { ReactComponent as BotIcon } from '../../images/chatbot/bot-icon.svg';
import '../../ChatbotStyles/TypingIndicator.scss';

interface TypingIndicatorProps {
  statusMessage?: string;
}

export const TypingIndicator = ({ statusMessage }: TypingIndicatorProps) => {
  return (
    <div className="typing-indicator">
      <div className="bot-avatar">
        <BotIcon width={20} height={20} />
      </div>
      <div className="typing-content-wrapper">
        <div className="typing-bubble">
          <span className="status-text">{statusMessage}</span>
        </div>
      </div>
    </div>
  );
};
